import React, { useState } from 'react';

const ContactTab = () => {
  const [showContact, setShowContact] = useState(false);

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg sm:text-xl font-light text-black mb-2">Contact Vendor</h3>
        <p className="text-base text-gray-600 font-light mb-6">Get in touch with the vendor to discuss your event needs</p>
      </div>
      
      <div className="space-y-4">
        <button 
          onClick={() => setShowContact(!showContact)}
          className="w-full sm:w-auto px-6 py-3 bg-black text-white rounded-lg font-light hover:bg-gray-800 transition-colors"
        >
          {showContact ? 'Hide contact' : 'Show contact information'}
        </button>
        
        {showContact && (
          <div className="p-6 border border-gray-200 rounded-lg">
            <p className="text-sm text-gray-600 mb-2 font-light">Contact information will be available after booking.</p>
            <p className="text-xs text-gray-500 font-light">For security reasons, vendor contact details are only shared with confirmed bookings.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactTab;

